module.exports = __webpack_public_path__ + "media/images/number_2_red-201ab45da438018e26e73c3a47024faa.png";